import { Item } from './Item';

export enum ContentReferenceType {
  CHAPTER = 'CHAPTER',
  PAGE = 'PAGE',
  BOOKMARK = 'BOOKMARK',
  QUESTION = 'QUESTION',
}

export enum EditionReferenceType {
  PAGE = 'PAGE',
  CHAPTER = 'CHAPTER',
  ALL = 'ALL',
  NONE = 'NONE',
}

export enum AssignmentReferenceType {
  PAGE = 'PAGE',
  CHAPTER = 'CHAPTER',
  ALL = 'ALL',
  DOCUMENT = 'DOCUMENT',
}

type BaseReference = EditionReferenceType | AssignmentReferenceType | ContentReferenceType;

export interface InitialReference<T extends BaseReference = BaseReference> extends Item {
  referenceType: T;
  startId: number;
  endId: number;
}
